import { DateHelper } from "../../../../Common/DateHelper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { DateTime } from "luxon";

export class ICateringTemplate extends ODataSelect
{
    public MenuTemplate_Id = '';
    public Menu_Id = '';
    public Description = '';
    public Deleted = false;
    public MenuItems = "";
    public MinimumBookingDuration = 0;
    public Name = '';
    public ConcurrencyStamp = ''
    public Node_Id = 0;

    
    public init(response: any, nodeId: number): ICateringTemplate
    {
        super.init(response, nodeId);
        return this;
    }

}


export class ICateringMenuExpanded extends ODataSelect
{
    public Node_Id = 0;
    public Menu_Id = '';
    public Name = '';
    public Description = '';
    public Short_Description = '';
    public ImageURI = '';
    public Status = '';
    public ConcurrencyStamp = '';
    public Available_From = DateTime.now();
    public Available_Until = DateTime.now();
    public Menu_MenuItems: IMenuItems[] = [];

    public toExpand()
    {
        return 'Menu_MenuItems($expand=MenuItem($expand=MenuItem_Restrictions($expand=Restriction)))';
    }

    public init(response: any, nodeId: number): ICateringMenuExpanded
    {
        super.init(response, nodeId)
        return {
            ...response,
            Node_Id: response.Node_Id,
            Menu_Id: response.Menu_Id,
            Name: response.Name,
            Description: response.Description,
            Short_Description: response.Short_Description,
            ImageURI: response.ImageURI,
            Status: response.Status,
            ConcurrencyStamp: response.ConcurrencyStamp,
            Available_From: DateHelper.fromIsoByNode(response.Available_From, nodeId),
            Available_Until: DateHelper.fromIsoByNode(response.Available_Until, nodeId),
            Menu_MenuItems: response.Menu_MenuItems,
        }
    }
}

export class ICateringRestrictions extends ODataSelect
{
    public Restriction_Id = '';
    public Section = '';
    public ImageURI = '';
    public Name = '';
    public ConcurrencyStamp = '';


    public init(response: any, nodeId: number): ICateringRestrictions
    {
        super.init(response, nodeId);
        return this;
    }
}

export interface IMenuItemView
{
    MenuItemId: string;
}

export interface IMenuItems
{
    MenuItem_Id: string;
    Menu_Id: string;
    MenuItem: IMenuItem;
}

export interface IMenuItem
{
    Description: string;
    Status: Status;
    UnitPrice: number;
    Classification: Classification;
    RetailPrice: number;
    Name: string;
    Supplier_Id: string;
    MenuItem_Id: string;
    ConcurrencyStamp: string;
    NutritionalInformation: string;
    OrderPolicy_Id: string;
    ImageURI: string;
    CreatedAt: string;
    MenuItem_Restrictions: ICateringRestriction[];
}


export interface ICateringRestriction
{
    Restriction_Id: string;
    Restriction: ICateringRestrictionDetails;
}

export interface ICateringRestrictionDetails
{
    Restriction_Id: string;
    Section: string;
    ImageURI: string;
    Name: string;
    ConcurrencyStamp?: string;
}

export interface ICateringMenu
{
    Node_Id: number;
    Menu_Id: string;
    Name: string;
    Description: string;
    Short_Description: string;
    Available_From: DateTime;
    Available_Until: DateTime;
    ImageURI: string;
    Status: string;
    ConcurrencyStamp: string;
    Menu_MenuItems: IMenuItems[];
}

export type Classification = "MenuItemClassificationBeverage" | "MenuItemClassificationSnack" | "MenuItemClassificationFood"

export type Status = "StatusActive" | "StatusInactive"